// Inside your GuestGuard (e.g., guest.guard.ts)
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage'; // Assuming you use this
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
canActivate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

  console.log('--- GuestGuard: Checking activation ---');

  const isPasswordReset = this.localStorageService.retrieve('isPasswordReset') === 'true';
  const isAuthenticated = this.localStorageService.retrieve('authenticationToken') !== null;
  
  console.log('isPasswordReset flag:', isPasswordReset);
  console.log('isAuthenticated:', isAuthenticated);

  // Condition 1: If it's a password reset flow, allow activation
  if (isPasswordReset) {
    console.log('GuestGuard: Password reset flag is true. Allowing navigation.');
    return true;
  }

  // Condition 2: If the user is already authenticated (has a token), redirect to home
  if (isAuthenticated) {
    console.log('GuestGuard: User is authenticated. Redirecting to home.');
    this.localStorageService.clear('isPasswordReset'); 
    return this.router.createUrlTree(['/home']);
  }

  // Condition 3: Otherwise, the user is a guest, so allow activation
  console.log('GuestGuard: User is a guest. Allowing navigation.');
  return true;
}
}